/*
 * サブシステム名：営業所別帳票出力
 * 機能名：営業所別帳票出力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdMonthRangeBox from '@/components/DdMonthRangeBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'

export default {
  name: 'EigyoshobetsuOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdMonthRangeBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {},
    copyCon: {},
    chohyoSbt: '0',
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    ymDisp: false,
    eigyoshoDisp: false,
    seikyuTomeSbtDisp: false,
    unchinKakuteiSbtDisp: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        this.ymDisp = true
        this.eigyoshoDisp = true
        this.seikyuTomeSbtDisp = true
        this.unchinKakuteiSbtDisp = true
      } else if (this.chohyoSbt === '1') {
        this.ymDisp = true
        this.eigyoshoDisp = true
        this.seikyuTomeSbtDisp = true
        this.unchinKakuteiSbtDisp = true
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    }
    // 営業所マスタフィルター <-- ここまで
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    settingStartYm: function (p) {
      this.$set(this.conditions, 'startYm', p)
    },
    settingEndYm: function (p) {
      this.$set(this.conditions, 'endYm', p)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispCsvNm = `営業所別日計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp3010/CsvDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispCsvNm = `営業所別収支実績表_${this.getTimeStamp()}.csv`
        post = '/api/v1/D2bzmp3020/CsvDownload'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispPdfNm = `営業所別日計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp3010/PdfDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispPdfNm = `営業所別収支実績表_${this.getTimeStamp()}.xlsm`
        post = '/api/v1/D2bzmp3020/ExcelOutput'
        this.HttpClient
          .requestFileByPost(post, this.conditions).then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          })
        return
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      var msg
      if (this.ymDisp) {
        if (!this.conditions.startYm) {
          this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startYm && this.conditions.endYm) {
          var startYmd = Date.parse(this.conditions.startYm + '/01')
          var endYmd = Date.parse(this.conditions.endYm + '/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endYm[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      return true
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      var today = new Date()
      var togetsu = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth() + 1)).slice(-2)
      this.conditions = {
        daySbt: '01',
        seikyuTomeSbt: '99',
        unchinKakuteiSbt: '99',
        startYm: togetsu,
        endYm: togetsu,
        startEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : '',
        endEigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : ''
      }
      /*
      // 表示制御
      this.conditions.daySbt = '01'
      this.conditions.seikyuTomeSbt = '99'
      this.conditions.unchinKakuteiSbt = '99'
      this.$set(this.conditions, 'startYm', togetsu)
      this.$set(this.conditions, 'endYm', togetsu)
      // dd-code-text-boxにbindしている項目は明示的にNullを設定する事
      this.conditions.startEigyoshoCd = !this.eigyoshoLockFlg ? this.userEigyoshoCd : ''
      this.conditions.endEigyoshoCd = !this.eigyoshoLockFlg ? this.userEigyoshoCd : ''
      */
      // 表示制御
      this.chohyoSbt = '0'
      this.ymDisp = true
      this.eigyoshoDisp = true
      this.seikyuTomeSbtDisp = true
      this.unchinKakuteiSbtDisp = true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
